import { Component, HostBinding, Input } from '@angular/core';
import { LayoutOffset } from '../../core/types/layout';
import { commonPaddingClass } from '../../core/utilities/layout';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class CardComponent {

  @Input() public padding?: LayoutOffset = 'md';
  @Input() @HostBinding('class.fill-container') public fill?: boolean;
  @Input() @HostBinding('class.with-shadow') public shadow?: boolean;

  @HostBinding('class')
  protected get classes(): string {
    return commonPaddingClass(this.padding);
  }

}
